export const appVersion = '1.31.0-rc.1';
